<svg class="circle" aria-hidden="true" height="100%" width="100%" viewBox="0 0 100 100">
  @for (circleElement of segments(); track circleElement) {
    <circle
      class="circle__segment"
      [attr.stroke-dasharray]="dashArray()"
      [attr.cx]="cx"
      [attr.cy]="cy"
      [attr.r]="radius"
      [ngClass]="circleElement.color"
      [attr.stroke-dashoffset]="dashOffset()"
      [attr.transform]="'rotate(' + getAngle(circleElement.filled) + ' ' + cx + ' ' + cy + ')'"
      xmlns="http://www.w3.org/2000/svg"
      fill="transparent" />
  }
  <text class="circle__text" x="50%" xmlns="http://www.w3.org/2000/svg" y="56%">
    {{ current() }} / {{ maxAmount() }}
  </text>
</svg>
@if (progressText()) {
  <p class="progress-text">{{ progressText() }}</p>
}
